<mat-card class="control-listing"
          md-colors="{background: 'background-hue-2'}"
          clDropElement
          (clDrop)="detailViewService.drop($event, module, isFiltered)"
          (clOver)="detailViewService.dragOver($event,module, isFiltered)"
          (clLeave)="detailViewService.leave($event)">
    <div class="card-information module-information"
         fxLayout="row">
        <mat-icon>developer_board</mat-icon>
        <div class="module-label"
             *ngIf="!showMultiLineTitle()">
            {{ getModuleTitle() }}
        </div>
        <div class="module-label"
             *ngIf="showMultiLineTitle()"
             fxLayout="column">
            <span>{{ getModuleTitle() }}</span>
            <div fxLayout="row">
                <span class="module-title-second-line"
                      *ngIf="showLocationTitle()"
                      matTooltip="Location"
                      matTooltipPosition="below">
                    {{ module.locationName }}
                </span>
                <span *ngIf="module.jobNumber"
                      class="module-title-second-line">
                    Job Number: {{ module.jobNumber }}
                </span>
            </div>
        </div>
        <div fxFlex></div>
    </div>
    <div class="device-list"
         heightWatcherDirective>
        <dl-device-card *ngFor="let device of filteredDevices; let index = index"
                     [device]="device"
                     [index]="index"
                     [module]="module">
        </dl-device-card>
    </div>
</mat-card>
